/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { ReactElement, useMemo } from 'react';
import { Dropdown as DropdownLib, Menu } from 'antd';
import compareByDate from '@rootCommon/utilities/compareByDate';
import './Dropdown.scss';

type Props = {
  trigger?: ReactElement;
  header?: ReactElement;
  items: Array<any>;
  keyProp?: string | number;
  renderItem: (item: any) => ReactElement;
  classNameItem?: string;
  classNameBlock?: string;
  emptyText?: string | JSX.Element;
  newestToOldest?: boolean;
};

const Dropdown = ({
  trigger: TriggerComponent,
  items: itemsInitial = [],
  keyProp = 'id',
  renderItem,
  classNameItem = '',
  classNameBlock = '',
  header,
  emptyText,
  newestToOldest,
}: Props): JSX.Element => {
  const items = useMemo(() => (newestToOldest
    ? itemsInitial?.sort((a, b) => compareByDate(a.createdAt, b.createdAt))
    : itemsInitial), [itemsInitial, newestToOldest]);

  const renderMenu = (items: Array<any>, keyProp: string | number) => (
    <Menu className={`${classNameBlock} custom-dropdown`}>
      {header && <Menu.Item className="dropdown-header">{header}</Menu.Item>}

      {items && items.map((e) => (
        <Menu.Item
          key={e[keyProp]}
          className={classNameItem}
          disabled={e.isDisabled}
        >
          {renderItem(e)}
        </Menu.Item>
      ))}
      {!items.length && emptyText && (
      <div className="mt-1 mb-1 text-center">
        <span className="text-empty">{emptyText}</span>
      </div>
      )}
    </Menu>
  );

  return (
    <DropdownLib overlay={renderMenu(items, keyProp)} trigger={['click']} placement="bottomCenter">
      <a className="ant-dropdown-link" href="#">
        {TriggerComponent}
      </a>
    </DropdownLib>
  );
};

export default Dropdown;
